export class ParametrosURL {
    constructor(
        public parametros?: string
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/entities/parametrosURL_entity.ts